import { render, staticRenderFns } from "./CNewsList.vue?vue&type=template&id=5009f85a&"
import script from "./CNewsList.vue?vue&type=script&lang=ts&"
export * from "./CNewsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports